module.exports = __webpack_public_path__ + "img/icon.a0c1eb1d.svg";